import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./Avatar.module.css";
/**
 * Avatar circular com iniciais do Azim CRM.
 */
export function Avatar({ name, initials, color = "var(--neutral-500)", size = 28, className }) {
    // Normaliza: remove espaços leading/trailing, divide por sequências de espaços,
    // filtra partes vazias e usa spread (...) para preservar surrogate pairs (emoji).
    const ini = initials ??
        (name
            ? name
                .trim()
                .split(/\s+/)
                .filter(Boolean)
                .slice(0, 2)
                .map((w) => [...w][0] ?? "")
                .join("")
            : "?");
    return (_jsx("span", { title: name, "aria-label": name ?? ini, className: [styles.avatar, className ?? ""].filter(Boolean).join(" "), style: {
            width: size,
            height: size,
            background: color,
            fontSize: size * 0.4,
        }, children: ini }));
}
/**
 * Grupo de avatares sobrepostos.
 */
export function AvatarGroup({ people, size = 26, max = 4 }) {
    const shown = people.slice(0, max);
    const extra = people.length - max;
    return (_jsxs("span", { className: styles.group, children: [shown.map((p, i) => (_jsx("span", { className: styles.groupItem, style: { marginLeft: i ? -size * 0.32 : 0 }, children: _jsx(Avatar, { ...p, size: size }) }, i))), extra > 0 && (_jsxs("span", { className: styles.groupExtra, style: {
                    marginLeft: -size * 0.32,
                    width: size,
                    height: size,
                    fontSize: size * 0.36,
                }, "aria-label": `+${extra} pessoas`, children: ["+", extra] }))] }));
}
//# sourceMappingURL=Avatar.js.map